import { Reducer } from 'redux';
import { Action } from 'Store/types';

export enum ActionTypes {
  SET_SCORE_PERFIL = '@scorePerfil/SET',
}

export type ScorePerfil = number;

export type ScorePerfilReducer = Reducer<ScorePerfil, Action<ActionTypes>>;
